import { ComponentDataDestService } from '../component-data-dest.service';
import { environment } from '../../../environment/environment';
import { Observable } from 'rxjs';

/**
 * Bulk-apply group rotation to all group-calendar events in a year (single backend request).
 * Payload: { year: number, sequence: number[] }
 */
export function apply_group_calendar_rotation(
  componentDataDestService: ComponentDataDestService,
  data: { year: number; sequence: number[] }
): Observable<unknown> {
  const year = Number(data.year);
  const sequence = Array.isArray(data.sequence)
    ? data.sequence.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0)
    : [];
  if (!Number.isFinite(year) || year < 2000 || sequence.length === 0) {
    return new Observable((obs) => obs.error(new Error('year and sequence are required')));
  }
  return componentDataDestService.http.post(
    `${environment.apiUrl}/events/group-calendar/apply-rotation`,
    { year, sequence },
    { withCredentials: true }
  );
}
